<template>
  <div class="grid-container content-page dashbord-soignant">

    <div class="title-page"><h4>Carnet de bord soignant</h4></div>

    <div class="grid-x grid-margin-x">

      <div class="small-12 medium-12 large-12 cell ">

         <ul class="nav-dashbord">
          <li><router-link :to="{ name: 'faq' }"><i class="fas fa-info-circle"></i>Accéder à la FAQ</router-link></li>
          <li><router-link :to="{ name: 'edit_account_caregiver' }"><i class="fas fa-user"></i>Gérer mon profil</router-link></li>
          <li><router-link :to="{ name: 'invite-child-caregiver' }"><i class="fas fa-child"></i>Ajouter un enfant</router-link></li>
        </ul>

        <div class="box-edit-avatar">

          <div v-if="!currentUser.avatar" class="bubble edit-avatar right txtleft" :class="{on: !currentUser.avatar}">
            <span>
              <div>Pensez à modifier votre avatar.</div>
            </span>
          </div>

          <div class="avatar-profil">
            <div class="avatar-cover">
              <caregiver-avatar :user="currentUser" />
              <router-link class="edit" :to="{ name: 'edit_account_caregiver' }" title="Editez son avatar"><i class="far fa-edit"></i></router-link>
            </div>
            <div class="infos">
              <h3>{{currentUser.first_name}} {{currentUser.last_name}}</h3>
              <span>Inscrit depuis {{formatDate(currentUser.signup_date)}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="small-12 medium-12 large-12 cell ">
        <div class="box-table-child">
          <table class="tableau zebre avectri">
            <thead>
              <tr>
                <th :class="{[sortDirection]: 'name' === sortProp}" @click="e => updateSort('name')">Enfant</th>
                <th :class="{[sortDirection]: 'rendezVous' === sortProp}" @click="e => updateSort('rendezVous')">Prochain rendez-vous</th>
                <th :class="{[sortDirection]: 'autoEvaluation' === sortProp}" @click="e => updateSort('autoEvaluation')">Humeur</th>
                <th :class="{[sortDirection]: 'jeu' === sortProp}" @click="e => updateSort('jeu')">Dernier jeu joué</th>
                <th class="not-arrow" ></th>
                <th class="not-arrow" ></th>
              </tr>
            </thead>
            <tbody>

              <item-child v-for="child in children" :user="child"/>

            </tbody>
          </table>
        </div>
        <hr>
      </div>
    </div>
  </div>

</template>


<script>
  // TODO retirer ce qui sert a kedal
  import { mapGetters, mapActions } from 'vuex'
  import { mapState } from 'vuex'
  import chroma from 'chroma-js'
  import { formatDate, dateFromString } from '@/functions'

  import Bouton from '@/components/Bouton'
  import ItemBadge from '@/components/ItemBadge'
  import ItemTeam from '@/components/ItemTeam'
  import ItemCommunity from '@/components/ItemCommunity'
  import ItemNotif from '@/components/ItemNotif'
  import ItemFiche from '@/components/ItemFiche'
  import TitlePage from '@/components/TitlePage'
  import TitleBox from '@/components/TitleBox'
  import TitleFiche from '@/components/TitleFiche'
  import AvatarProfil from '@/components/AvatarProfil'
  import IfUser from '@/components/IfUser'
  import Avatar from '@/components/Avatar'

  import MedicalTeam from './dashboardComponents/MedicalTeam'
  import BadgesList from './dashboardComponents/BadgesList'
  import ChildTracking from './dashboardComponents/ChildTracking'
  import ParentMenu from './dashboardComponents/ParentMenu'
  import EventCalendar from './dashboardComponents/EventCalendar'
  import EventTimeline from './dashboardComponents/EventTimeline'
  import ItemChild from '@/components/ItemChild'

  import CaregiverAvatar from '@/components/CaregiverAvatar'

  export default {
    components: {AvatarProfil, Avatar, Bouton, ItemBadge, ItemTeam, ItemChild, ItemCommunity, ItemNotif, ItemFiche, TitlePage, TitleFiche, TitleBox, MedicalTeam, BadgesList, ChildTracking, ParentMenu, EventCalendar, EventTimeline, IfUser, CaregiverAvatar },
    computed: {
      ...mapGetters(['completeName', 'childName']),
      ...mapState(['subaccounts']),
      currentUser() {
        return this.$store.state.me
      },
      community() {
        let subaccounts = this.$store.state.subaccounts
        let relatives = subaccounts.relatives.concat(subaccounts.friends)
        if (subaccounts.child) {
          relatives = relatives.concat(subaccounts.child)
        }
        return relatives
      },
      children() {
        return this.subaccounts.children.sort((a, b) => {
          let a_value
          let b_value
          if(this.sortProp == 'name') {
            a_value = a.first_name + a.last_name
            b_value = b.first_name + b.last_name
          } else if(this.sortProp === 'autoEvaluation') {
            let a_aa= a.auto_evaluations
            a_value = a_aa[a_aa.length - 1].value

            let b_aa= b.auto_evaluations
            b_value = b_aa[b_aa.length - 1].value
          } else if(this.sortProp === 'rendezVous') {
            let now = Date.now()
            a_value = a.families[0].mainAccount.appointments
              .map(n => dateFromString(n.date))
              .filter(d => d > now)
              .sort()[0]
            b_value = b.families[0].mainAccount.appointments
              .map(n => dateFromString(n.date))
              .filter(d => d > now)
              .sort()[0]
          } else if(this.sortProp === 'jeu') {
            a_value = a.games.map(g => g.played_at).filter(g => g).sort()[0]
            b_value = a.games.map(g => g.played_at).filter(g => g).sort()[0]
          }

          if (a_value > b_value) {
            return this.sortDirection === 'asc' ? -1 : 1
          } else if (a_value < b_value) {
            return this.sortDirection === 'asc' ? 1 : -1
          } else {
            return 0
          }

        });
      },
      newGame() {
        let games = this.$store.state.me.games
        if (!games) {
          return undefined
        }
        return games.find(g => g.score === 0)

      },
      lastGame() {
        let games = this.$store.state.games
        if (!games) {
          return undefined
        }
        return games.find(g => g.score !== 0)

      }
    },
    beforeRouteEnter(to, from, next){
      next(vm => {
        // access to component instance via `vm`
        if(vm.$store.state.me.account_type !== 'caregiver'){
          next({ name: 'dashboard-' + vm.$store.state.me.account_type });
        }
      })
    },
    data() {
      let scale = chroma.scale(['25243f', '7497cb', '65d4ff', 'd78d81', '25243f'])

      return {
        bubble: true ,
        bgcolor: scale(new Date().getHours() / 24).toString(),
        postInscriptionMessage: '',
        phase_next: false,
        identifier: '',
        sortDirection: 'desc',
        sortProp: 'name'
      }
    },
    methods: {
      ...mapActions(['sendInvitation', 'addNotice']),
      updateSort(prop) {
        if (prop === this.sortProp) {
          this.sortDirection = this.sortDirection == 'asc' ? 'desc' : 'asc'
        } else {
          this.sortDirection = 'desc'
          this.sortProp = prop
        }
        console.log(this.sortDirection, this.sortProp)
      },
      formatDate,
      closeBubble () {
        this.bubble = false;
      },
      async send (e) {
        e.preventDefault();

        try {
          this.sendInvitation({ identifier: this.identifier, role: 'child' })
          this.addNotice({message: `L'invitation a été envoyée avec succès.`})
        } catch (ex) {
          console.log(ex)
        }
      }
    }
  }
</script>

<style>
.asc::after { content: ' ⯅' }
.desc::after { content: ' ⯆' }
</style>
